<template>
  <div class="form-detail">
    <mk-radio-group
      v-model="activeName"
      size="small"
      @change="handleOnChange"
    >
      <mk-radio-button
        v-for="(radio, index) in radios"
        :key="index"
        :label="radio.label"
      >
        {{ radio.name }}
      </mk-radio-button>
    </mk-radio-group>
    <div class="detail-table">
      <list-biz
        :config="tableConfig"
        :data="data"
        :page="params.page"
        :page-size="params.pageSize"
        :total="params.total"
        :pagination-with-table="false"
        @on-current-change="handleOnCurrentChange"
      >
      </list-biz>
    </div>
  </div>
</template>

<script>
import { MKMATERIALSVC } from '@api'

const reportTableConfig = {
  name: 'reportTableConfig',
  mode: 'table',
  list: {
    type: 'Table',
    columns: [{
      prop: 'phone',
      label: '手机号'
    }, {
      prop: 'signTime',
      label: '初次签到时间'
    }]
  }
}

const orderTableConfig = {
  name: 'orderTableConfig',
  mode: 'table',
  list: {
    type: 'Table',
    columns: [{
      prop: 'phone',
      label: '手机号'
    }, {
      prop: 'reservationTime',
      label: '初次预约时间'
    }]
  }
}
export default {
  name: 'FormDetail',
  data () {
    return {
      activeName: 'order-detail',
      radios: [{
        name: '外派驻点明细',
        label: 'order-detail'
      }, {
        name: '楼盘签到明细',
        label: 'report-detail'
      }],
      tableConfig: orderTableConfig,
      params: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      data: []
    }
  },
  mounted () {
    this.estateIndustryStatisticStationDetailedGet()
  },
  methods: {
    handleOnChange (name) {
      this.params.page = 1
      this.params.pageSize = 10
      this.initDetail(name)
    },
    handleOnCurrentChange (page) {
      this.params.page = page
      this.initDetail(this.activeName)
    },
    initDetail (name) {
      const config = {
        'order-detail': {
          tableConfig: orderTableConfig,
          ajax: this.estateIndustryStatisticStationDetailedGet
        },
        'report-detail': {
          tableConfig: reportTableConfig,
          ajax: this.estateIndustryStatisticEstateSignDetailedGet
        }
      }
      this.tableConfig = config[name].tableConfig
      config[name].ajax()
    },
    // 楼盘签到明细
    async estateIndustryStatisticEstateSignDetailedGet () {
      const params = {
        formId: this.$route.query.id,
        ...this.params
      }
      const { success, data: { data, total, page, pageSize } } = await MKMATERIALSVC.EstateIndustryApi.estateIndustryStatisticEstateSignDetailedGet(params)
      if (success) {
        this.params = {
          total,
          page,
          pageSize
        }
        this.data = data
      }
    },
    // 外派驻点明细
    async estateIndustryStatisticStationDetailedGet () {
      const params = {
        formId: this.$route.query.id,
        ...this.params
      }
      const { success, data: { data, total, page, pageSize } } = await MKMATERIALSVC.EstateIndustryApi.estateIndustryStatisticStationDetailedGet(params)
      if (success) {
        this.params = {
          total,
          page,
          pageSize
        }
        this.data = data
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-detail {
  display: flex;
  flex-direction: column;

  .detail-table {
    flex: 1;
    margin-top: 10px;
    width: 600px;
  }
}
</style>
